export default "__VITE_ASSET__BiGS7_5p__"